import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { checkPixelCollision } from '../ndgmr.Collision-phaser';

export default class DraggableSprite extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, name) {
    super(scene,0,0, ABCyaPhaser.Images.DEFAULT_ATLAS, name);

    this.enabled = true;
    this.lastPosX = 0;
    this.lastPosY = 0;

    /** @type {Phaser.GameObjects.Image[]} */
    this.hitTargets = [];
    this.doClickAction = (sender) => {};
    this.outListener = (sender) => {};
    this.hitListener = (sender, target) => {};

    this.setInteractive({ draggable: true });
    this.name = name;

    this.on(Phaser.Input.Events.GAMEOBJECT_DRAG, this.handlePress,this);
    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick,this);
    this.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, this.doClickUp,this);

    this.deselect();
  }

  handlePress (pointer, x, y) {
    if (!this.enabled) return;
    this.x = x;
    this.y = y;
  }

  doClick () {
    if (this.parentContainer) {
      this.parentContainer.bringToTop(this);
    }
    else {
      this.scene.children.bringToTop(this);
    }

    this.doClickAction(this);
  }

  doClickUp () {
    if (!this.enabled) return;

    for (let i = 0; i < this.hitTargets.length; i++) {
      const target = this.hitTargets[i];

      const collision = checkPixelCollision(this, target, 0);

      // if (collision &&  this.sameRotation(this, target) ) {
      if (collision) {
        this.hitListener(this, target);

        // just one target can be hit, so return
        return;
      }
    }

    this.outListener(this);
  }

  deselect () {
    this.selected = false;
  }

  moveToLastPosition () {
    ABCyaPhaser.Tweens.addTween(this, 500, { x: this.lastPosX, y: this.lastPosY }, Phaser.Math.Easing.Quadratic.Out);
  }
}